import React from 'react';
import Icon from '../../../components/AppIcon';

const TransactionStatusCard = ({ transaction }) => {
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('ar-EG')?.format(amount);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('ar-EG', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    })?.format(date);
  };

  const getStatusInfo = (status) => {
    const statusMap = {
      'pending': {
        label: 'قيد المراجعة',
        color: 'text-warning',
        bgColor: 'bg-warning/10',
        borderColor: 'border-warning/20',
        icon: 'Clock'
      },
      'approved': {
        label: 'معتمد',
        color: 'text-success',
        bgColor: 'bg-success/10',
        borderColor: 'border-success/20',
        icon: 'CheckCircle'
      },
      'active': {
        label: 'نشط',
        color: 'text-primary',
        bgColor: 'bg-primary/10',
        borderColor: 'border-primary/20',
        icon: 'Activity'
      },
      'rejected': {
        label: 'مرفوض',
        color: 'text-error',
        bgColor: 'bg-error/10',
        borderColor: 'border-error/20',
        icon: 'XCircle'
      }
    };
    return statusMap?.[status] || statusMap?.['pending'];
  };

  const statusInfo = getStatusInfo(transaction?.status);

  return (
    <div className="bg-card rounded-lg border border-border p-4 hover:shadow-warm transition-all duration-250" dir="rtl">
      <div className="flex items-start justify-between mb-3">
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-1">
            <Icon name="FileText" size={16} color="var(--color-primary)" />
            <h4 className="font-semibold text-foreground">{transaction?.contractNumber}</h4>
          </div>
          <p className="text-sm text-muted-foreground">{transaction?.contractType}</p>
        </div>
        <span className={`px-3 py-1 rounded-full text-xs font-semibold border ${statusInfo?.bgColor} ${statusInfo?.color} ${statusInfo?.borderColor} flex items-center gap-1`}>
          <Icon name={statusInfo?.icon} size={12} />
          {statusInfo?.label}
        </span>
      </div>

      <div className="space-y-2">
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">العقار:</span>
          <span className="text-foreground font-medium">{transaction?.propertyTitle}</span>
        </div>
        
        <div className="flex items-center justify-between text-sm">
          <span className="text-muted-foreground">المبلغ:</span>
          <span className="text-foreground font-bold">{formatCurrency(transaction?.amount)} دينار</span>
        </div>

        {transaction?.startDate && (
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">تاريخ البدء:</span>
            <span className="text-foreground">{formatDate(transaction?.startDate)}</span>
          </div>
        )}

        {transaction?.endDate && (
          <div className="flex items-center justify-between text-sm">
            <span className="text-muted-foreground">تاريخ الانتهاء:</span>
            <span className="text-foreground">{formatDate(transaction?.endDate)}</span>
          </div>
        )}
      </div>

      {/* Progress Indicator for Pending */}
      {transaction?.status === 'pending' && (
        <div className="mt-3 pt-3 border-t border-border">
          <div className="flex items-center gap-2 text-xs text-muted-foreground">
            <div className="flex-1 h-1.5 bg-muted rounded-full overflow-hidden">
              <div className="h-full bg-warning animate-pulse" style={{ width: '60%' }}></div>
            </div>
            <span>جاري المعالجة</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default TransactionStatusCard;